module.exports = __webpack_public_path__ + "static/case_12-653dcc267dafae63d2ed736aff14644f.jpg";